// Lead forms on lander pages (sections/lander-form.liquid).
// Posts the form as URL-encoded fields to the Make.com webhook set in theme settings.
(function () {
  var STANDARD_KEYS = ['form_id', 'page_title', 'website', 'name', 'email', 'store_url', 'phone', 'revenue', 'newsletter_consent'];
  var TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  var STORAGE_KEY = 'lander_attribution';

  // Keep first-touch UTMs for the session so they survive in-page navigation.
  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; } catch (e) {}
    TRACKING_KEYS.forEach(function (key) {
      if (params.get(key) && !stored[key]) stored[key] = params.get(key);
    });
    if (!stored.referrer && document.referrer) stored.referrer = document.referrer;
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  function normalizeUrl(value) {
    value = value.trim();
    if (!value) return value;
    return /^https?:\/\//i.test(value) ? value : 'https://' + value;
  }

  function looksLikeDomain(value) {
    return /^https?:\/\/[^\s.]+\.[^\s]{2,}$/i.test(value);
  }

  function setError(form, message) {
    var el = form.querySelector('.lander-form__error');
    el.textContent = message;
    el.hidden = !message;
  }

  function trackLead(formId) {
    // No personal data goes to analytics, only the form ID.
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lander_lead', { form_id: formId }); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: formId }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { form_id: formId }); } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'lander_lead', form_id: formId });
  }

  function init(form) {
    var tracking = attribution();
    var button = form.querySelector('button[type="submit"]');
    var success = form.parentNode.querySelector('[data-lander-success]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setError(form, '');

      form.querySelectorAll('[data-type="url"]').forEach(function (input) {
        input.value = normalizeUrl(input.value);
        input.setCustomValidity(input.value && !looksLikeDomain(input.value) ? 'Enter your store address, like yourstore.com' : '');
      });
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var webhook = form.dataset.webhook;
      if (!webhook) {
        setError(form, 'This form is not connected yet. Add the lead webhook URL in Theme settings > Landing pages.');
        return;
      }

      var data = new FormData(form);
      var body = new URLSearchParams();
      var extra = [];
      data.forEach(function (value, key) {
        body.append(key, value);
        if (STANDARD_KEYS.indexOf(key) === -1 && value) {
          var label = form.querySelector('[name="' + key + '"]');
          label = label && form.querySelector('label[for="' + label.id + '"]');
          extra.push((label ? label.textContent.trim() : key) + ': ' + value);
        }
      });
      if (!data.has('newsletter_consent')) body.append('newsletter_consent', 'false');
      body.append('extra', extra.join('\n'));
      body.append('page_url', window.location.origin + window.location.pathname);
      body.append('submitted_at', new Date().toISOString());
      TRACKING_KEYS.concat('referrer').forEach(function (key) { body.append(key, tracking[key] || ''); });

      button.disabled = true;
      fetch(webhook, { method: 'POST', body: body })
        .then(function (response) {
          if (!response.ok) throw new Error('Webhook responded ' + response.status);
          trackLead(data.get('form_id'));
          if (form.dataset.redirect) {
            window.location.href = form.dataset.redirect;
            return;
          }
          form.hidden = true;
          success.hidden = false;
          success.focus();
        })
        .catch(function () {
          button.disabled = false;
          setError(form, 'Something went wrong sending this. Please try again, or email info@movefwd.co.');
        });
    });
  }

  document.querySelectorAll('[data-lander-form]').forEach(init);
})();
